import { useEffect, useState } from 'react'

import { Backbone } from '../../../types/backbone'
import { get } from '../../../utils/api'

export const useBackboneData = (productId: number) => {
  const [backbones, setBackbones] = useState<Backbone[]>([])
  const [backbonesDft, setBackbonesDft] = useState<Backbone[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    get<Backbone[]>(`/backbones/?product=${productId}`)
      .then((data) => {
        setBackbones(data)
        setBackbonesDft(data.filter((backbone) => backbone.isDefault))
      })
      .finally(() => setIsLoading(false))
  }, [productId])

  return { backbones, backbonesDft, backbonesIsLoading: isLoading }
}
